<template>
	<div>
		<v-row align="center" justify="center">
			<v-col cols="12" md="7">
				<v-card class="register-card mx-auto my-3" elevation="2">
					<v-card-text class="pa-5 pa-sm-7">
						<div class="text-center mb-5">
							<div class="text-h5 font-weight-bold secondary--text">عضویت در سایت</div>
							<div class="grey--text text-body-2 mt-2">فرآیند عضویت را گام‌به‌گام تکمیل کنید.</div>
						</div>

						<div class="d-flex justify-center flex-wrap align-center mb-4" style="gap: 5px;">
							<div v-for="s in steps" :key="s.value" class="step-pill d-flex align-center" :class="{
								'step-pill--active': currentStep === s.value,
								'step-pill--done': currentStep > s.value
							}">
								<v-icon color="success" v-if="currentStep > s.value" size="16" class="ml-1">mdi-check</v-icon>
								{{ s.label }}
							</div>
						</div>

						<v-alert v-if="errorMessage" outlined type="error" dense class="mb-4">
							{{ errorMessage }}
						</v-alert>

						<v-window v-model="currentStep" touchless class="pt-2">
							<v-window-item :value="1">
								<v-form ref="mobileForm" @submit.prevent="sendOTP">
									<v-text-field v-model="form.mobile" label="شماره موبایل" prepend-inner-icon="mdi-cellphone" outlined maxlength="11" type="tel" :rules="[rules.required, rules.mobile]" />
									<v-text-field v-model="form.phone" label="تلفن  ثابت" prepend-inner-icon="mdi-phone" outlined maxlength="20" type="tel" :rules="[rules.phone]" />
									<v-row class="mx-0 mb-6">
										<v-col cols="4" class="px-0">
											<v-text-field label="کد امنیتی" maxLength="4" v-model="registerCaptcha">
											</v-text-field>
										</v-col>
										<v-col cols="8" sm="5" md="5" class="" style="direction: ltr;display: flex;align-items: center;justify-content: end;">
											<v-btn class="mr-1" color="secondary" small fab icon @click="refreshRegisterCaptcha()"><v-icon>mdi-refresh</v-icon></v-btn>
											<CaptchaImage ref="registerCaptcha" :codeType="['0']" style="direction: ltr;" />
										</v-col>
									</v-row>
									<v-btn color="secondary" block large :loading="otpLoading" type="submit">
										{{ settings.hasRegisterOtpSms ? 'ارسال کد تائید' : 'تایید و ادامه' }}
									</v-btn>
								</v-form>
							</v-window-item>

							<v-window-item :value="2">
								<v-form ref="otpForm" @submit.prevent="verifyOtp()">
									<div class="text-body-2 grey--text mb-3 text-center">
										کد ارسال شده به <span class="secondary--text font-weight-bold">{{ form.mobile }}</span> را وارد کنید.
									</div>
									<div class="d-flex justify-center flex-row-reverse otp-container mb-3">
										<v-text-field class="code-inputs center-input" outlined v-model="smsCode[0]" dense hide-details maxLength="1" type="tel" tabindex="1" @input="focusOnNext()" focused />
										<v-text-field class="code-inputs center-input" outlined v-model="smsCode[1]" dense hide-details maxLength="1" type="tel" tabindex="2" @input="focusOnNext()" @keyup.backspace="focusOnPrevios()" />
										<v-text-field class="code-inputs center-input" outlined v-model="smsCode[2]" dense hide-details maxLength="1" type="tel" tabindex="3" @input="focusOnNext()" @keyup.backspace="focusOnPrevios()" />
										<v-text-field class="code-inputs center-input" outlined v-model="smsCode[3]" dense hide-details maxLength="1" type="tel" tabindex="4" @input="focusOnNext()" @keyup.backspace="focusOnPrevios()" />
										<v-text-field class="code-inputs center-input" outlined v-model="smsCode[4]" dense hide-details maxLength="1" type="tel" tabindex="5" @keyup.backspace="focusOnPrevios()" />
									</div>
									<div class="text-center" style="min-height:55px">
										<v-btn v-if="sendCodeVisible" class="mr-1" color="secondary" :loading="otpLoading" text small @click="sendOTP()">ارسال مجدد کد تائید</v-btn>
										<Countdown v-if="currentStep === 2" class="black--text text-center fs-h3" @finish="sendCodeVisible = true" ref="countdown" />
									</div>

									<v-slide-x-transition :hide-on-leave="true">
										<div v-show="loginMode === 'roles'" class="pa-4">
											<div class="mb-3 text-center red--text">کاربر با این شماره موبایل قبلا ثبت شده است</div>
										</div>
									</v-slide-x-transition>

									<div class="d-flex" v-if="loginMode !== 'roles'">
										<v-btn text class="ml-2" :disabled="loading" @click="currentStep = 1">ویرایش موبایل</v-btn>
										<v-spacer />
										<v-btn color="secondary" :loading="loading" type="submit">تائید کد</v-btn>
									</div>
								</v-form>
							</v-window-item>

							<v-window-item :value="3">
								<v-form ref="nationalCodeForm" @submit.prevent="verifyNationalCode">
									<v-text-field v-model="form.nationalCode" label="کد ملی" prepend-inner-icon="mdi-card-account-details-outline" outlined maxlength="10" type="tel" :rules="[rules.required, rules.nationalCode]" />
									<div v-if="!settings.inquiryPersonInfoInRegister">
										<v-text-field class="" v-model="form.firstName" outlined label="نام" :rules="[(val) => !!val || 'نام را وارد کنید']" focused />
										<v-text-field class="" v-model="form.lastName" outlined label="نام خانوادگی" :rules="[(val) => !!val || 'نام خانوادگی را وارد کنید']" />
										<v-text-field class="" v-model="form.fatherName" outlined label="نام پدر" :rules="[(val) => !!val || 'نام پدر را وارد کنید']" />
										<v-text-field class="left-input" v-model="form.email" outlined label="ایمیل" :rules="[(val) => !!val || 'ایمیل را وارد کنید', (val) => isEmailValid() || 'ایمیل را به صورت صحیح وارد کنید']" required />
									</div>
									<div class="mb-10 d-flex">
										<div class="ml-1 pt-1">تاریخ تولد:</div>
										<date-picker ref="birthdate" auto-submit v-model="form.birthDate" format="YYYY-MM-DDTHH:mm:ss" display-format="dddd jDD jMMMM jYYYY" clearable />
									</div>
									<div class="identity-box pa-4 mb-4" v-if="identity && identity.id">
										<div class="text-subtitle-1 font-weight-bold mb-3 grey--text text--darken-2">اطلاعات استعلام شده:</div>
										<v-row dense>
											<v-col cols="12" sm="6"><strong>نام:</strong> {{ identity.firstName || '-' }}</v-col>
											<v-col cols="12" sm="6"><strong>نام خانوادگی:</strong> {{ identity.lastName || '-' }}</v-col>
											<v-col cols="12" sm="6"><strong>نام پدر:</strong> {{ identity.fatherName || '-' }}</v-col>
											<v-col cols="12" sm="6"><strong>کد ملی:</strong> {{ form.nationalCode }}</v-col>
											<v-col cols="12" sm="6"><strong>موبایل:</strong> {{ form.mobile }}</v-col>
										</v-row>
									</div>
									<v-btn color="secondary" block :loading="loading" type="submit" v-if="!identity || !identity.id || !identity.firstName">
										{{ settings.inquiryPersonInfoInRegister ? 'استعلام اطلاعات هویتی' : 'تایید و ادامه' }}
									</v-btn>
									<v-btn color="secondary" block @click="currentStep = 4" v-else>
										تایید اطلاعات و ادامه
									</v-btn>
								</v-form>
							</v-window-item>

							<v-window-item :value="4">
								<v-form ref="postalAddressForm" @submit.prevent="verifyAddress">
									<v-text-field v-model="form.postalCode" label="کد پستی" prepend-inner-icon="mdi-card-account-details-outline" outlined maxlength="10" type="tel" :rules="[rules.required, rules.postalCode]" />
									<div v-if="!settings.inquiryPostalAddressInRegister">
										<v-text-field class="" v-model="form.city" outlined label="شهر" :rules="[(val) => !!val || 'شهر را وارد کنید']" />
										<v-text-field class="" v-model="form.address" outlined label="آدرس" :rules="[(val) => !!val || 'آدرس را وارد کنید']" />
									</div>
									<div class="identity-box pa-4 mb-4" v-if="postalAddress && postalAddress.id">
										<div class="text-subtitle-1 font-weight-bold mb-3 grey--text text--darken-2">آدرس استعلام شده:</div>
										<v-row dense>
											<v-col cols="12" sm="12">{{ address.address || 'نامشخص' }}</v-col>
										</v-row>
									</div>
									<v-btn color="secondary" block :loading="loading" type="submit" v-if="!postalAddress || !postalAddress.id">
										{{ settings.inquiryPostalAddressInRegister ? 'استعلام کد پستی' : 'تایید و ادامه' }}
									</v-btn>
									<v-btn color="secondary" block @click="currentStep = 5" v-else>
										تایید اطلاعات و ادامه
									</v-btn>
								</v-form>
							</v-window-item>

							<v-window-item :value="5">
								<v-form ref="bankForm" @submit.prevent="verifyBankInfo">
									<v-text-field v-model="form.bankCard" label="شماره کارت (بدون خط تیره)" prepend-inner-icon="mdi-card-account-details-outline" outlined maxlength="16" type="tel" :rules="[rules.required, rules.bankCard]" />
									<div v-if="!settings.inquiryBankInRegister">
										<v-text-field class="left-input" v-model="form.iban" placeholder="IR" maxLength="26" outlined label="شماره شبا (با پیشوند IR)" :rules="[rules.iban]" />
										<v-text-field class="" v-model="form.bankName" outlined label="نام بانک" :rules="[(val) => !!val || 'نام بانک را وارد کنید']" />
									</div>
									<div class="identity-box pa-4 mb-8" v-if="bank && bank.id">
										<div class="text-subtitle-1 font-weight-bold mb-3 grey--text text--darken-2">اطلاعات بانکی استعلام شده:</div>
										<v-row dense>
											<v-col cols="12" sm="6"><strong>نام صاحب حساب:</strong> {{ bank.name || '-' }}</v-col>
											<v-col cols="12" sm="6"><strong>شماره حساب:</strong> {{ bank.accountNumber || '-' }}</v-col>
											<v-col cols="12" sm="6"><strong>شماره شبا:</strong> {{ bank.iban || '-' }}</v-col>
											<v-col cols="12" sm="6"><strong>نام بانک:</strong> {{ bank.bankName || '-' }}</v-col>
											<v-col cols="12" sm="6">
												<div v-if="bank.active" class="success--text d-flex">
													<v-icon size="16" class="ml-1" color="success">mdi-check</v-icon>
													<small>وضعیت حساب فعال</small>
												</div>
												<div v-else class="red--text d-flex">
													<v-icon size="16" class="ml-1" color="red">mdi-close</v-icon>
													<small>وضعیت حساب غیرفعال</small>
												</div>
											</v-col>
											<v-col cols="12" sm="6">
												<div v-if="bank.isMatch" class="success--text d-flex">
													<v-icon size="16" class="ml-1" color="success">mdi-check</v-icon>
													<small>تطابق کدملی</small>
												</div>
												<div v-else class="red--text d-flex">
													<v-icon size="16" class="ml-1" color="red">mdi-close</v-icon>
													<small>عدم تطابق کدملی</small>
												</div>
											</v-col>
										</v-row>
									</div>
									<v-btn color="secondary" block :loading="loading" type="submit" v-if="!bank || !bank.isMatch || !bank.active">
										{{ settings.inquiryBankInRegister ? 'استعلام اطلاعات بانکی' : 'تایید و ادامه' }}
									</v-btn>
									<v-btn color="secondary" block @click="currentStep = 6" v-else>
										تایید اطلاعات و ادامه
									</v-btn>
								</v-form>
							</v-window-item>

							<v-window-item :value="6">
								<v-form ref="familiarForm" @submit.prevent="verifyFamiliarInfo">
									<div class="mb-3">اطلاعات معرف های مشتری را در صورت وجود ثبت نمایید:</div>
									<div class="text-h5 grey--text text--darken-2 mt-3">معرف 1</div>
									<v-text-field class="mx-0" v-model="form.familiar1FirstName" maxlength="50" prepend-inner-icon="mdi-account" label="نام" />
									<v-text-field class="mx-0" v-model="form.familiar1LastName" maxlength="50" label="نام خانوادگی" />
									<v-text-field class="mx-0" v-model="form.familiar1Mobile" maxlength="20" label="شماره تماس" />

									<div class="text-h5 grey--text text--darken-2 mt-3">معرف 2</div>
									<v-text-field class="mx-0" v-model="form.familiar2FirstName" maxlength="50" prepend-inner-icon="mdi-account" label="نام" />
									<v-text-field class="mx-0" v-model="form.familiar2LastName" maxlength="50" label="نام خانوادگی" />
									<v-text-field class="mx-0" v-model="form.familiar2Mobile" maxlength="20" label="شماره تماس" />


									<v-btn class="mt-4" color="secondary" block type="submit">
										تایید اطلاعات و ادامه
									</v-btn>
								</v-form>
							</v-window-item>

							<v-window-item :value="7">
								<div class="identity-box pa-4 mb-4">
									<div class="text-h5 font-weight-bold mb-3 grey--text text--darken-4 mb-6 text-center">بررسی نهایی اطلاعات</div>

									<div v-if="form.username" class="font-weight-bold mb-3 grey--text text--darken-2">نام کاربری: {{ form.username }}</div>

									<div class="font-weight-bold mb-1 grey--text text--darken-2">اطلاعات هویتی</div>
									<v-row dense v-if="identity" class="pr-4">
										<v-col cols="12" sm="6"><strong>نام:</strong> {{ identity.firstName || '-' }}</v-col>
										<v-col cols="12" sm="6"><strong>نام خانوادگی:</strong> {{ identity.lastName || '-' }}</v-col>
										<v-col cols="12" sm="6"><strong>نام پدر:</strong> {{ identity.fatherName || '-' }}</v-col>
										<v-col cols="12" sm="6"><strong>تاریخ تولد:</strong> {{ new Date(form.birthDate).toLocaleDateString('fa-IR') || '-' }}</v-col>
										<v-col cols="12" sm="6"><strong>کد ملی:</strong> {{ form.nationalCode }}</v-col>
										<v-col cols="12" sm="6"><strong>موبایل:</strong> {{ form.mobile }}</v-col>
										<v-col cols="12" sm="6"><strong>ایمیل:</strong> {{ form.email || '-' }}</v-col>
									</v-row>

									<div class="font-weight-bold mb-1 grey--text text--darken-2 mt-3">آدرس</div>
									<v-row dense v-if="address" class="pr-4">
										<v-col cols="12" sm="12"><strong>کدپستی:</strong> {{ form.postalCode || '-' }}</v-col>
										<v-col cols="12" sm="12">{{ address.address || '-' }}</v-col>
									</v-row>

									<div class="font-weight-bold mb-1 grey--text text--darken-2 mt-3">اطلاعات بانکی</div>
									<v-row dense v-if="bank" class="pr-4">
										<v-col cols="12" sm="6"><strong>شماره کارت:</strong> {{ form.bankCard || '-' }}</v-col>
										<v-col cols="12" sm="6" v-if="settings.inquiryBankInRegister"><strong>نام صاحب حساب:</strong> {{ bank.name || '-' }}</v-col>
										<v-col cols="12" sm="6"><strong>شماره حساب:</strong> {{ bank.accountNumber || '-' }}</v-col>
										<v-col cols="12" sm="6"><strong>شماره شبا:</strong> {{ bank.iban || '-' }}</v-col>
										<v-col cols="12" sm="6"><strong>نام بانک:</strong> {{ bank.bankName || '-' }}</v-col>
										<v-col cols="12" sm="6" v-if="settings.inquiryBankInRegister"><strong>وضعیت حساب:</strong> {{ bank.active ? 'فعال' : 'غیرفعال' }}</v-col>
									</v-row>

									<div class="font-weight-bold mb-1 grey--text text--darken-2 mt-3">معرف ها</div>
									<v-row dense v-if="bank" class="pr-4">
										<v-col cols="12" class=""><strong>معرف 1</strong></v-col>
										<v-col cols="12"><strong>نام:</strong> {{ form.familiar1FirstName || '-' }}</v-col>
										<v-col cols="12"><strong>نام خانوادگی:</strong> {{ form.familiar1LastName || '-' }}</v-col>
										<v-col cols="12"><strong>شماره تماس:</strong> {{ form.familiar1Mobile || '-' }}</v-col>

										<v-col cols="12" class="pt-4"><strong>معرف 2</strong></v-col>
										<v-col cols="12"><strong>نام:</strong> {{ form.familiar2FirstName || '-' }}</v-col>
										<v-col cols="12"><strong>نام خانوادگی:</strong> {{ form.familiar2LastName || '-' }}</v-col>
										<v-col cols="12"><strong>شماره تماس:</strong> {{ form.familiar2Mobile || '-' }}</v-col>
									</v-row>

								</div>
								<v-checkbox v-model="identityConfirmed" label="اطلاعات فوق مورد تایید من است." hide-details class="mt-0 mb-3" />
								<v-btn color="secondary" block :disabled="!identityConfirmed || loading" :loading="loading" @click="submitRegister">
									تایید و ادامه
								</v-btn>

								<v-alert v-if="errorMessage" outlined type="error" dense class="mb-4 mt-4">
									{{ errorMessage }}
								</v-alert>
							</v-window-item>

							<v-window-item :value="8">
								<div class="text-center py-4">
									<v-icon color="success" size="72">mdi-check-circle</v-icon>
									<div class="success--text text-h6 mt-3">ثبت‌نام با موفقیت تکمیل شد.</div>
									<div class="success--text text-h6 my-3">نام کاربری: {{ form.username }}</div>
									<div class="success--text text-h6 my-3">کلمه عبور: {{ form.password }}</div>
									<div class="grey--text mt-2 mb-5">اکنون می‌توانید درخواست وام ثبت کنید.</div>
									<v-btn color="secondary" @click="$emit('loanRequest', form.id)" :loading="loading">ثبت درخواست</v-btn>
								</div>
							</v-window-item>
						</v-window>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { get } from 'vuex-pathify'
	import { setCookie, getCookie } from '@/util/helpers'
	import ThemeManager from '@/util/theme-manager.js'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
	import CaptchaImage from '@/components/app/CaptchaImage.vue'
	import { cloneDeep, identity } from 'lodash'

	export default {
		name: 'Register',
		components: {
			CaptchaImage: CaptchaImage,
			'date-picker': VuePersianDatetimePicker,
		},
		props: {
			nationalCode: { type: String },
		},
		data() {
			return {
				registerCaptcha: '',
				sendCodeVisible: false,
				otpLoading: false,
				validParameters: true,
				show1: false,
				show2: false,
				currentStep: 1,
				loading: false,
				errorMessage: '',
				identityConfirmed: false,
				loginMode: 'static',
				form: {
					mobile: '',
					otp: '',
					nationalCode: '',
					birthDate: '',
					bankCard: '',
					username: '',
					password: null,
					confirmPassword: null,
					familiar1FirstName: '',
					familiar1LastName: '',
					familiar1Mobile: '',
					familiar2FirstName: '',
					familiar2LastName: '',
					familiar2Mobile: '',
					firstName: '',
					lastName: '',
					email: '',
					city: '',
					address: '',
					postalCode: '',
					iban: '',
					bankName: ''
				},
				inquirys: {
					shahkar: null,
					personInfo: null,
					postalAddress: null,
					bankCardInfo: null,
					ibanMatch: null,
					ibanInfo: null,
				},
				smsCode: [null, null, null, null, null],
				allSteps: [
					{ value: 1, label: 'موبایل' },
					{ value: 2, label: 'کد تائید' },
					{ value: 3, label: 'کد ملی' },
					{ value: 4, label: 'کد پستی' },
					{ value: 5, label: 'اطلاعات بانکی' },
					{ value: 6, label: 'معرف ها' },
					{ value: 7, label: 'بررسی اطلاعات' },
					{ value: 8, label: 'پایان' }
				],
				rules: {
					required: (v) => !!v || 'این فیلد الزامی است.',
					mobile: (v) => /^(?:0|۰)?(?:9|۹)[\d۰-۹]{9}$/.test(v || '') || 'شماره موبایل صحیح نیست.',
					phone: (v) => /^[\d۰-۹]{0,20}$/.test(v || '') || 'شماره تلفن ثابت صحیح نیست.',
					iban: (v) => /^IR[\d۰-۹]{24}$/.test(v || '') || 'شماره شبا صحیح نیست.',
					otp: (v) => /^[\d۰-۹]{4,6}$/.test(v || '') || 'کد تائید معتبر نیست.',
					nationalCode: (v) => this.checkCodeMeli(v || '') || 'کد ملی معتبر نیست.',
					postalCode: (v) => /^[\d۰-۹]{10}$/.test(v || '') || 'کد پستی صحیح نیست.',
					bankCard: (v) => /^[\d۰-۹]{16}$/.test(v || '') || 'شماره کارت صحیح نیست.'

				},
				roles: [],
				roleNames: { member: 'مشتری', agent: 'نماینده', admin: 'مدیر سیستم', marketer: 'بازاریاب', customermarketer: 'بازاریاب' }
			}
		},
		computed: {
			...get('siteConfig', ['isCloud', 'longTitle']),
			...get('auth', ['getCurrentUser']),
			...get('agentAppSettings', [
				'settings'
			]),
			customerCode() {
				return this.getCurrentUser?.userData?.customer?.code || 0
			},
			identity() {
				if (!this.settings.inquiryPersonInfoInRegister)
					return {
						firstName: this.form.firstName,
						lastName: this.form.lastName,
						fatherName: this.form.fatherName,
						email: this.form.email,
					}
				// set id to identity of inquiry result to detect it comes from inquiry or not
				return this.inquirys.personInfo?.panelResultJson ? Object.assign({ id: this.inquirys.personInfo?.id }, JSON.parse(this.inquirys.personInfo?.panelResultJson)) : null
			},
			shahkarMatch() {
				return this.inquirys.shahkar?.panelResultJson ? JSON.parse(this.inquirys.shahkar?.panelResultJson)?.isMatch : false
			},
			postalAddress() {
				if (!this.settings.inquiryPostalAddressInRegister)
					return {
						city: this.form.city,
						address: this.form.address
					}
				return this.inquirys.postalAddress?.panelResultJson ? Object.assign({ id: this.inquirys.postalAddress?.id }, JSON.parse(this.inquirys.postalAddress?.panelResultJson)) : null
			},
			address() {
				if (!this.settings.inquiryPostalAddressInRegister)
					return { address: this.form.address }
				return this.inquirys.postalAddress?.result ? { address: this.inquirys.postalAddress.result } : null
			},
			bank() {
				if (!this.settings.inquiryBankInRegister)
					return {
						iban: this.form.iban,
						bankName: this.form.bankName
					}
				const bankCardInfo = this.inquirys.bankCardInfo?.panelResultJson ? JSON.parse(this.inquirys.bankCardInfo?.panelResultJson) : null
				const ibanMatch = this.inquirys.ibanMatch?.panelResultJson ? JSON.parse(this.inquirys.ibanMatch?.panelResultJson) : null
				const ibanInfo = this.inquirys.ibanInfo?.panelResultJson ? JSON.parse(this.inquirys.ibanInfo?.panelResultJson) : null

				return bankCardInfo || ibanMatch || ibanInfo ? Object.assign({ id: this.inquirys.bankCardInfo?.id }, { ...bankCardInfo, ...ibanMatch, ...ibanInfo }) : null
			},
			steps() {
				let steps = cloneDeep(this.allSteps)
				if (!this.settings.hasRegisterOtpSms)
					steps = steps.filter(x => x.value !== 2)
				else
					steps = steps.filter(x => x.value !== 6)
				return steps
			}
		},
		created() {
		},
		mounted() {
			if (this.nationalCode)
				this.form.nationalCode = this.nationalCode
			this.manageAffiliate()
			this.manageAgentCode()
		},
		methods: {
			manageAffiliate() {
				const mrk = this.$route.query.mrk
				if (!mrk) return
				setCookie('mrk', mrk, 180)
				const customerCode = this.$route.params.customerCode || 0
				api.post(`Visitor/LogVisitor/?customerCode=${customerCode}&mrkCode=${mrk}`, {}, { authHeader: false, contentType: 'application/json' }).catch(() => { })
			},
			manageAgentCode() {
				const agn = this.$route.query.agn
				if (!agn) return
				setCookie('agn', agn, 180)
			},
			clearError() {
				this.errorMessage = ''
			},
			async sendOTP() {
				if (!this.$refs.mobileForm.validate()) return
				if (!this.$refs.registerCaptcha.verify(this.registerCaptcha)) {
					this.errorMessage = 'کد امنیتی صحیح نمی باشد.'
					return
				}
				this.clearError()
				if (!this.settings.hasRegisterOtpSms) {
					this.currentStep = 3
					return
				}
				this.otpLoading = true
				try {
					await api.post(`account/SendOTP/${this.form.mobile.toEnglishDigits()}?customerCode=${this.customerCode}`, {}, { authHeader: false, contentType: 'application/json' })
					this.smsCode = [null, null, null, null, null]
					this.currentStep = this.settings.hasRegisterOtpSms ? 2 : 3
					setTimeout(() => {
						var input = document.querySelector(".code-inputs input")
						if (input) input.focus()
						this.$refs.countdown.start()
					}, 100)
				} catch (err) {
					this.errorMessage = err.message || 'ارسال کد تائید ناموفق بود.'
				} finally {
					this.otpLoading = false
				}
			},
			async verifyOtp(role = '') {
				if (!this.$refs.otpForm.validate()) return
				if (!this.smsCode.every(x => !!x || x == 0)) { this.errorMessage = 'رمز تاییدیه پیامکی وارد نشده است'; return }
				this.clearError()
				this.loading = true
				try {
					let user = {
						customerCode: this.customerCode,
						otpCode: this.smsCode.join('').toEnglishDigits(),
						mobile: this.form.mobile.toEnglishDigits(),
						role: role,
						appSmsType: 8
					}
					var res = await api.post('account/OTPToken', user, { authHeader: false, contentType: 'application/x-www-form-urlencoded;charset=utf-8' })
					if (res.jwtToken || res.roles) {
						this.errorMessage = 'کاربر با این شماره موبایل قبلا در سیستم ثبت نام شده است.'
					}
					else {
						this.currentStep = 3
					}
				} catch (err) {
					if (err.message === 'کاربر یافت نشد.') {
						this.currentStep = 3
						return
					}
					this.errorMessage = err.message || 'کد تائید صحیح نمی‌باشد.'
				} finally {
					this.loading = false
				}
			},
			async verifyNationalCode() {
				if (!this.$refs.nationalCodeForm.validate()) return
				if (!this.form.birthDate) {
					this.errorMessage = 'تاریخ تولد را وارد کنید'
					return
				}
				this.clearError()
				this.loading = true
				this.inquirys.shahkar = null
				this.inquirys.personInfo = null
				try {
					await api.post(
						`account/PreCheckRegistration?nationalCode=${this.form.nationalCode.toEnglishDigits()}&customerCode=${this.customerCode}`,
						{},
						{ authHeader: false, contentType: 'application/json' }
					)
					if (!this.settings.inquiryPersonInfoInRegister) {
						this.currentStep = 4
						return
					}
					const shahkarRes = await api.post(
						`inquiry/Shahkar?nationalCode=${this.form.nationalCode.toEnglishDigits()}&mobile=${this.form.mobile.toEnglishDigits()}&customerCode=${this.customerCode}`,
						{},
						{ authHeader: false, contentType: 'application/json' }
					)
					this.inquirys.shahkar = shahkarRes
					if (!this.shahkarMatch) {
						throw new Error('کد ملی و شماره موبایل با هم مطابقت ندارند.')
					}

					const personInfoRes = await api.post(
						`inquiry/PersonInfo?nationalCode=${this.form.nationalCode.toEnglishDigits()}&birthDate=${this.form.birthDate}&customerCode=${this.customerCode}`,
						{},
						{ authHeader: false, contentType: 'application/json' }
					)
					this.inquirys.personInfo = personInfoRes

				} catch (err) {
					this.errorMessage = err.message || 'استعلام اطلاعات هویتی انجام نشد.'
				} finally {
					this.loading = false
				}
			},
			async verifyAddress() {
				if (!this.$refs.postalAddressForm.validate()) return
				this.clearError()
				this.inquirys.postalAddress = null
				if (!this.settings.inquiryPostalAddressInRegister) {
					this.currentStep = 5
					return
				}
				this.loading = true
				try {
					const verifyRes = await api.post(
						`inquiry/PostalAddress?postalCode=${this.form.postalCode.toEnglishDigits()}&customerCode=${this.customerCode}`,
						{},
						{ authHeader: false, contentType: 'application/json' }
					)
					this.inquirys.postalAddress = verifyRes
				} catch (err) {
					this.errorMessage = err.message || 'استعلام آدرس پستی انجام نشد.'
				} finally {
					this.loading = false
				}
			},
			async verifyBankInfo() {
				if (!this.$refs.bankForm.validate()) return
				this.clearError()
				this.inquirys.bank = null
				if (!this.settings.inquiryBankInRegister) {
					this.currentStep = 6
					return
				}
				this.loading = true
				try {
					const bankCardInfoRes = await api.post(
						`inquiry/BankCardInfo?cardNumber=${this.form.bankCard.toEnglishDigits()}&customerCode=${this.customerCode}`,
						{},
						{ authHeader: false, contentType: 'application/json' }
					)
					this.inquirys.bankCardInfo = bankCardInfoRes

					const ibanInfoRes = await api.post(
						`inquiry/IbanInfo?iban=${this.bank.iban.toEnglishDigits()}&customerCode=${this.customerCode}`,
						{},
						{ authHeader: false, contentType: 'application/json' }
					)
					this.inquirys.ibanInfo = ibanInfoRes

					const ibanMatchRes = await api.post(
						`inquiry/IbanMatch?iban=${this.bank.iban.toEnglishDigits()}&nationalCode=${this.form.nationalCode.toEnglishDigits()}&birthDate=${this.form.birthDate}&customerCode=${this.customerCode}`,
						{},
						{ authHeader: false, contentType: 'application/json' }
					)
					this.inquirys.ibanMatch = ibanMatchRes

				} catch (err) {
					this.errorMessage = err.message || 'استعلام شماره کارت انجام نشد.'
				} finally {
					this.loading = false
				}
			},
			verifyFamiliarInfo() {
				if (!this.$refs.familiarForm.validate()) return
				this.currentStep = 7
			},
			async submitRegister() {
				this.clearError()
				this.loading = true
				try {
					const inquiryIds = Object.values(this.inquirys).filter(v => v !== null).map(v => v.id)
					let bankAccounts = []
					if (this.bank?.accountNumber)
						bankAccounts.push({ accountNumber: this.bank.accountNumber, bank: this.bank.bankName, branch: '' })
					if (this.bank?.iban)
						bankAccounts.push({ accountNumber: this.bank.iban, bank: this.bank.bankName, branch: '' })
					if (this.form?.bankCard)
						bankAccounts.push({ accountNumber: this.form.bankCard, bank: this.bank.bankName, branch: '' })
					let data = {
						customerCode: this.customerCode,
						mobile: this.form.mobile.toEnglishDigits(),
						nationalCode: this.form.nationalCode.toEnglishDigits(),
						birthDate: this.form.birthDate,
						firstName: this.identity?.firstName,
						lastName: this.identity?.lastName,
						fatherName: this.identity?.fatherName,
						postalCode: this.form?.postalCode.toEnglishDigits() || '',
						address: this.address?.address || '',
						city: this.postalAddress?.city || '',
						bankAccountsJson: JSON.stringify(bankAccounts),
						inquiryIds: inquiryIds,
						mrkCode: getCookie('mrk') || '',
						agnCode: String(getCookie('agn')) || '',
						email: this.form.email?.toEnglishDigits(),
						password: this.form.password?.toEnglishDigits(),
						confirmPassword: this.form.confirmPassword?.toEnglishDigits(),
						agnCode: String(this.getCurrentUser?.userData?.id)
					}
					const reg = await api.post(
						'account/StepFormRegister',
						data,
						{ authHeader: false, contentType: 'application/json' }
					)
					this.form.username = reg.username
					this.form.password = reg.password
					this.form.id = reg.id
					this.currentStep = 8
				} catch (err) {
					this.errorMessage = err.message || 'تکمیل ثبت‌نام انجام نشد.'
				} finally {
					this.loading = false
				}
			},
			redirectToPanel() {
				this.loading = true
				const user = {
					username: this.form.username,
					password: this.form.password,
				}
				this.$store.dispatch('auth/login', user).then((to) => {
					// router.replace('/member/LoanRequest/' + response).catch(() => { })
					this.$router.replace('/member/LoanRequest/').catch(() => { })
				}).catch(error => {
					this.loading = false
					this.errorMessage = error.message || error.toString()
				})
			},
			checkCodeMeli(code) {
				const L = code.length
				if (L < 8 || parseInt(code, 10) === 0) return false
				const normalized = ('0000' + code).substr(L + 4 - 10)
				if (parseInt(normalized.substr(3, 6), 10) === 0) return false
				const c = parseInt(normalized.substr(9, 1), 10)
				let s = 0
				for (let i = 0; i < 9; i++) s += parseInt(normalized.substr(i, 1), 10) * (10 - i)
				s = s % 11
				return (s < 2 && c === s) || (s >= 2 && c === (11 - s))
			},
			isEmailValid() {
				return this.form.email &&
					/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g.test(this.form.email)
			},
			focusOnNext() {
				var currInput = document.activeElement
				if (!currInput.value)
					return
				if (currInput?.tagName.toLowerCase() == "input") {
					var inputs = document.getElementsByTagName("input")
					for (var i = 0; i < inputs.length; i++) {
						if (inputs[i] == currInput) {
							var next = inputs[i + 1]
							if (next && next.focus) {
								next.focus()
							}
							break
						}
					}
				}
			},
			focusOnPrevios() {
				var currInput = document.activeElement
				if (currInput?.tagName.toLowerCase() == "input") {
					var inputs = document.getElementsByTagName("input")
					for (var i = inputs.length - 1; i > 0; i--) {
						if (inputs[i] == currInput) {
							var next = inputs[i - 1]
							if (next && next.focus) {
								next.focus()
							}
							break
						}
					}
				}
			},
			checkPasswordPolicy() {
				if (!(this.form.password.length > 8))
					return false
				return true
			},
			refreshRegisterCaptcha() {
				this.$refs.registerCaptcha.refresh()
			},
		}
	}
</script>

<style scoped
	lang="scss">
		.otp-container {
			column-gap: 10px;

			.code-inputs {
				width: 45px;
				max-width: 45px;
				height: 45px;
				max-height: 45px;
				margin: 0;
				text-align: center;

				input {
					text-align: center;
				}
			}
		}

		#register-view {
			background: linear-gradient(160deg, #f6f8ff 0%, #eef2ff 45%, #ffffff 100%);
			min-height: 100vh;
		}

		.register-card {
			border-radius: 20px;
			overflow: hidden;
		}

		.step-pill {
			font-size: 11px;
			padding: 6px 10px;
			border-radius: 20px;
			background: #eef1f6;
			color: #7d8797;
			transition: all 0.2s ease;
			white-space: nowrap;
		}

		.step-pill--active {
			background: #e3f2fd;
			color: #1565c0;
			font-weight: 700;
		}

		.step-pill--done {
			background: #e8f5e9;
			color: #2e7d32;
		}

		.identity-box {
			border: 1px solid #e2e8f0;
			border-radius: 12px;
			background: #f8fafc;
		}

		@media (max-width: 600px) {
			.step-pill {
				font-size: 10px;
				padding: 5px 8px;
			}
		}
	</style>
